export default __webpack_public_path__ + "static/img1-b90de898acab6573b14d78e7829be884.png";